import _ from 'lodash'
import React from 'react'
import serverMenuStrings from '../components/ServerSelector/server-selector.json'
import localize from '../store/localize'
import { launcherOpenUrl } from '../launcherBackend/launcher-command'
import { SERVERS_UPDATE_ACTIVE, APP_SET_SHOW_SETTINGS_STATE } from '../constants'
import { actions as toasterActions } from '../features/Toaster'
import attributes from '../settings/references.json'

function getLocalizedTestServerWarning(locale) {
    const text = localize(serverMenuStrings, locale, 'testServerWarning')
    const linkText = localize(serverMenuStrings, locale, 'learnMore')
    const title = localize(serverMenuStrings, locale, 'onTestServer')
    const href = 'https://community.eveonline.com/support/test-servers/'
    const linkSettings = {
        href,
        title: localize(serverMenuStrings, locale, 'externalLink'),
        onClick: (e) => {
            e.preventDefault()
            launcherOpenUrl(href)
        },
    }
    const content = (
        <div>
            {text}
            <br />
            <a {...linkSettings}>{linkText}</a>
        </div>
    )
    return { title, content }
}

function SendTestServerWarning(server, store) {
    if (server === 'tq') return

    const localized = _.mapValues(attributes.languages, (value, key) =>
        getLocalizedTestServerWarning(key),
    )

    store.dispatch(toasterActions.addWarning({ localized }))
}

const NotifierMiddleware = store => next => (action) => {
    switch (action.type) {
        case SERVERS_UPDATE_ACTIVE: {
            const result = next(action)
            SendTestServerWarning(action.payload, store)
            return result
        }

        case APP_SET_SHOW_SETTINGS_STATE: {
            const result = next(action)
            if (action.payload) {
                store.dispatch(toasterActions.useSettingsQueue())
            } else {
                store.dispatch(toasterActions.useNormalQueue())
            }
            return result
        }

        default:
            return next(action)
    }
}

export default NotifierMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/NotifierMiddleware.js